export type { Component, ComponentConnectorCapabilities } from '@chili-studio/connector-types';

/**
 * @experimental This is still experimental and might change in future releases.
 */
export enum ComponentPreviewType {
    thumbnail = 'thumbnail',
    highest = 'highest',
    medium = 'medium',
}
